
 import { getMessaging, getToken, onMessage  } from "firebase/messaging";

export default {
    methods: {
        initializeFirebasePushNotificationService() {
            // making sure initialization happens only once
            if (sessionStorage.getItem('fcm_data_init') === true) {
                return;
            }

            let fcm_data = localStorage.getItem('fcm_data');
            if (fcm_data) {
                let fcm_data_decoded = JSON.parse(fcm_data);
                if (fcm_data_decoded.auth_id == this.$store.state.authenticatedUserData.user.id) {
                    return;
                }
            }

            const messaging = this.$root.messaging;
            navigator.serviceWorker.register(this.$root.serverBasePath + '/firebase-messaging-sw.js')
                .then((registration) => {
                    getToken(messaging, { vapidKey: 'BOKdBSZBD5cjGModaWCE-bZz6y2sgOkuNRDCCISaT9P4d8zSFYtZwLqBCvHqxqSr5ddUE85Osx-zO9rOl43Mt94' }).then((currentToken) => {
                        if (currentToken) {
                            axios.post("api/save_fcm_token", { fcm_token: currentToken })
                                .then((response) => {
                                    localStorage.setItem('fcm_data', JSON.stringify({
                                        auth_id: response.data.auth_id,
                                        fcm_uuid: response.data.fcm_uuid,
                                        created: response.data.created,
                                    }));
                                });
                  
                        } else {
                          // Show permission request UI
                          console.log('No registration token available. Request permission to generate one.');
                          // ...
                        }
                      }).catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);
                        // ...
                      });

                    // messaging.useServiceWorker(registration);
                    // messaging.requestPermission()
                    //     .then(function () {
                    //         return messaging.getToken();
                    //     })
                    //     .then(function (token) {
                    //         axios.post("api/save_fcm_token", { fcm_token: token })
                    //             .then((response) => {
                    //                 localStorage.setItem('fcm_data', JSON.stringify({
                    //                     auth_id: response.data.auth_id,
                    //                     fcm_uuid: response.data.fcm_uuid,
                    //                     created: response.data.created,
                    //                 }));
                    //             });
                    //     });
                });

            // marking as fcm data has beed initialized
            sessionStorage.setItem('fcm_data_init', true);
        },
    }
}
